"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OWGameToJSON = exports.OWGameFromJSONTyped = exports.OWGameFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function OWGameFromJSON(json) {
    return OWGameFromJSONTyped(json, false);
}
exports.OWGameFromJSON = OWGameFromJSON;
function OWGameFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'gameId': json['gameId'],
        'name': json['name'],
        'description': json['description'],
        'events': json['events'],
        'logo': !(0, runtime_1.exists)(json, 'logo') ? undefined : json['logo'],
        'icon': !(0, runtime_1.exists)(json, 'icon') ? undefined : json['icon'],
        'devourGameLogo': !(0, runtime_1.exists)(json, 'devourGameLogo') ? undefined : json['devourGameLogo'],
        'bannerImageSmall': !(0, runtime_1.exists)(json, 'bannerImageSmall') ? undefined : json['bannerImageSmall'],
        'bannerImageLarge': !(0, runtime_1.exists)(json, 'bannerImageLarge') ? undefined : json['bannerImageLarge'],
        'landingImageSmall': !(0, runtime_1.exists)(json, 'landingImageSmall') ? undefined : json['landingImageSmall'],
        'landingImageLarge': !(0, runtime_1.exists)(json, 'landingImageLarge') ? undefined : json['landingImageLarge'],
        'thumbnailImage': !(0, runtime_1.exists)(json, 'thumbnailImage') ? undefined : json['thumbnailImage'],
        'timeRewardImage': !(0, runtime_1.exists)(json, 'timeRewardImage') ? undefined : json['timeRewardImage'],
        'isEventSupported': json['isEventSupported'],
        'isEventSupportReady': !(0, runtime_1.exists)(json, 'isEventSupportReady') ? undefined : json['isEventSupportReady'],
        'hasUserStats': !(0, runtime_1.exists)(json, 'hasUserStats') ? undefined : json['hasUserStats'],
        'steamAppId': !(0, runtime_1.exists)(json, 'steamAppId') ? undefined : json['steamAppId'],
        'slug': !(0, runtime_1.exists)(json, 'slug') ? undefined : json['slug'],
        'timeTrackedGame': !(0, runtime_1.exists)(json, 'timeTrackedGame') ? undefined : json['timeTrackedGame'],
        'seo': !(0, runtime_1.exists)(json, 'seo') ? undefined : (0, _1.OWGameSEOFromJSON)(json['seo']),
        'steamMatch': !(0, runtime_1.exists)(json, 'steamMatch') ? undefined : (0, _1.OWGameSteamMatchFromJSON)(json['steamMatch']),
        'steamData': !(0, runtime_1.exists)(json, 'steamData') ? undefined : (0, _1.OWGameSteamDataFromJSON)(json['steamData']),
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
    };
}
exports.OWGameFromJSONTyped = OWGameFromJSONTyped;
function OWGameToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'gameId': value.gameId,
        'name': value.name,
        'description': value.description,
        'events': value.events,
        'logo': value.logo,
        'icon': value.icon,
        'devourGameLogo': value.devourGameLogo,
        'bannerImageSmall': value.bannerImageSmall,
        'bannerImageLarge': value.bannerImageLarge,
        'landingImageSmall': value.landingImageSmall,
        'landingImageLarge': value.landingImageLarge,
        'thumbnailImage': value.thumbnailImage,
        'timeRewardImage': value.timeRewardImage,
        'isEventSupported': value.isEventSupported,
        'isEventSupportReady': value.isEventSupportReady,
        'hasUserStats': value.hasUserStats,
        'steamAppId': value.steamAppId,
        'slug': value.slug,
        'timeTrackedGame': value.timeTrackedGame,
        'seo': (0, _1.OWGameSEOToJSON)(value.seo),
        'steamMatch': (0, _1.OWGameSteamMatchToJSON)(value.steamMatch),
        'steamData': (0, _1.OWGameSteamDataToJSON)(value.steamData),
        'id': value.id,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
    };
}
exports.OWGameToJSON = OWGameToJSON;
